import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Action, State, StateContext } from "@ngxs/store";
import { createRequestAction, RequestState } from "ngxs-requests-plugin";

import { environment } from "../../../../environments/environment";
import { AppConfigService } from "../../services/app-config.service";
import { IMetaOption } from "../../interfaces/meta-options.interface";
import { GetExtraOptions, GetExtraOptionsFail, GetExtraOptionsSuccess } from "./extra-options.actions";
import { patchIdsAndEntities } from "../../../shared/utils/patch-ids-and-entities";

export interface ExtraOptionsStateModel {
  ids: number[];
  entities: {[key: number]: IMetaOption}
}

@RequestState('getExtraOptions')
@Injectable()
export class GetExtraOptionsRequestState {}

@State<ExtraOptionsStateModel>({
  name: 'extraOptions',
  defaults: {
    ids: [],
    entities: {}
  }
})
@Injectable()
export class ExtraOptionsState {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
  ) {}

  @Action(GetExtraOptions)
  getExtraOptions(
    { dispatch }: StateContext<ExtraOptionsStateModel>
  ) {
    const params = new HttpParams({ fromObject: {dbName: this.appConfig.dbName, dbVersion: "latest"} });
    const request = this.http.get(environment.api + 'db/meta/extra_options', {params});

    return dispatch(
      createRequestAction({
        request,
        state: GetExtraOptionsRequestState,
        successAction: GetExtraOptionsSuccess,
        failAction: GetExtraOptionsFail
      })
    );
  }

  @Action(GetExtraOptionsSuccess)
  getExtraOptionsSuccess(
    ctx: StateContext<ExtraOptionsStateModel>,
    { payload: response }: GetExtraOptionsSuccess
  ) {
    const extraOptions = Object.keys(response.content).map(key => {
      return {tag: key, ...response.content[key]};
    });

    patchIdsAndEntities(ctx, extraOptions, true, 'tag');
  }
}